import API_URL from '../config/api';

const API_ORIGIN = API_URL.replace(/\/api\/?$/, '');

export function normalizarUrlArquivo(url) {
  if (!url) return url;

  try {
    const parsed = new URL(url, window.location.origin);
    const fileIndex = parsed.pathname.indexOf('/files/');

    if (fileIndex >= 0) {
      return `${API_ORIGIN}${parsed.pathname.slice(fileIndex)}${parsed.search}${parsed.hash}`;
    }

    return parsed.href;
  } catch {
    const caminho = String(url).replace(/^\/+/, '');
    return `${API_ORIGIN}/${caminho}`;
  }
}
